module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Deviation Cause"},"no":{"title":"Avviksårsak"}}')
  delete Component.options._Ctor
}
